import { useField } from "formik";
import { SelectControl, SwitchControl } from "formik-chakra-ui";
import React, { useMemo } from "react";
import useCheckUserRole from "src/hooks/useCheckUserRole";
import * as AF from "src/types/formTemplate";

const PermissionLevels = [
  { label: "District Admin", value: "district-admin" },
  { label: "Org Admin", value: "org-admin" },
  { label: "School Admin", value: "school-admin" },
];
type Props = { questionId: uuid };
export const PermissionLevel: React.FC<Props> = ({ questionId }) => {
  const [switchField, ,] = useField(`permissionLevels.${questionId}.type`);

  const { isAvelaAdmin, isOrgAdmin, isDistrictAdmin, isSchoolAdmin } =
    useCheckUserRole();
  const permissions = useMemo(() => {
    if (isAvelaAdmin) {
      return PermissionLevels;
    }
    if (isOrgAdmin) {
      return PermissionLevels.filter((level) => level.value !== "admin");
    }
    if (isDistrictAdmin) {
      return PermissionLevels.filter((level) =>
        ["district-admin", "school-admin"].includes(level.value)
      );
    }
    if (isSchoolAdmin) {
      return PermissionLevels.filter((level) => level.value === "school-admin");
    }
    return [];
  }, [isAvelaAdmin, isDistrictAdmin, isOrgAdmin, isSchoolAdmin]);

  if (switchField.value === "disabled") {
    return null;
  }

  return (
    <SelectControl
      name={`permissionLevels.${questionId}.level`}
      isDisabled={switchField.value === "disabled"}
      label="Permission level"
      selectProps={{
        placeholder: "Select a permission level",
      }}
    >
      {permissions.map((option) => {
        return (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        );
      })}
    </SelectControl>
  );
};

const EXCLUDED_QUESTION_TYPE_FOR_PERMISSION_LEVEL: AF.QuestionType[] = [
  AF.GradesType,
];
type PermissionLevelSwitchProps = {
  questionId: uuid;
  questionType?: AF.Question<AF.WithId>["type"] | "";
};
export const PermissionLevelSwitch: React.FC<PermissionLevelSwitchProps> = ({
  questionId,
  questionType,
}) => {
  const [field, , helpers] = useField(`permissionLevels.${questionId}.type`);

  const onChangeHandler = React.useCallback(() => {
    const nextValue = field.value === "disabled" ? "checked" : "disabled";
    helpers.setValue(nextValue);
  }, [field.value, helpers]);

  if (
    questionType === undefined ||
    questionType === "" ||
    EXCLUDED_QUESTION_TYPE_FOR_PERMISSION_LEVEL.includes(questionType)
  ) {
    return null;
  }

  return (
    <SwitchControl
      name={`permissionLevels.${questionId}.type`}
      onChange={onChangeHandler}
      switchProps={{
        isChecked: field.value !== "disabled",
      }}
      label="Internal-only question"
      flexDirection="row-reverse"
      justifyContent="flex-end"
    />
  );
};
